import { getVehicleDiscountRate } from '@orcar/common-d2c';

/**
 * 정가(기준요금 원가) 대비 판매가 할인 정보 — 제주로 자사몰 할인율 노출용.
 *
 * ERP 요금표·Open API의 할인율 컬럼과 동일 공식을 쓴다:
 *   percentOff = floor((1 − 판매가 / 원가) × 100)
 * (서버 `calcDiscountRate`와 일치. 앵커=서버가 내려주는 `referencePrice`)
 *
 * 원가가 0 이하이거나 판매가가 원가 이상이면 할인 미노출(hasPromo=false).
 * 할인율/취소선은 반드시 이 한 곳에서만 계산한다(검색·홈·결제 동일 소스).
 */
export type PromoInfo = {
  /** 정가(기준요금 원가). */
  anchor: number;
  /** 실제 판매가(화면 표시가). */
  sale: number;
  /** 할인 금액(원가 − 판매가). */
  discountAmount: number;
  /** 할인율(%). */
  percentOff: number;
  /** 취소선·배지 노출 여부. */
  hasPromo: boolean;
};

export const computePromo = (
  anchor?: number | null,
  sale?: number | null,
): PromoInfo => {
  const a = anchor || 0;
  const s = sale || 0;
  const rate = getVehicleDiscountRate(sale, anchor);
  const valid = rate !== null;
  const percentOff = rate ?? 0;

  return {
    anchor: a,
    sale: s,
    discountAmount: valid ? a - s : 0,
    percentOff,
    hasPromo: valid && percentOff >= 1,
  };
};
